import { EnumLiteralsOf, RETRYABLE_ERROR_TYPES } from 'utils/types';

export const CampaignUpdateActionContext = Object.freeze({
  CAMPAIGNS: 'campaigns',
  ARCHIVED: 'archived',
  DETAILS: 'details'
});

export const CampaignColumnsKeyConstant = Object.freeze({
  NAME: 'name',
  OBJECTIVE: 'objectives',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  ACCOUNTS: 'accounts',
  STORES: 'stores',
  ITEMS: 'items'
});

export type CampaignUpdateActionContextType = EnumLiteralsOf<typeof CampaignUpdateActionContext>;
export type CampaignColumnsKeysType = EnumLiteralsOf<typeof CampaignColumnsKeyConstant>;

export const CampaignColumnsKeys = [
  CampaignColumnsKeyConstant.NAME,
  CampaignColumnsKeyConstant.OBJECTIVE,
  CampaignColumnsKeyConstant.START_DATE,
  CampaignColumnsKeyConstant.END_DATE,
  CampaignColumnsKeyConstant.ACCOUNTS,
  CampaignColumnsKeyConstant.STORES,
  CampaignColumnsKeyConstant.ITEMS
];

export const CampaignColumnsLabel = Object.freeze({
  [CampaignColumnsKeyConstant.NAME]: 'Name',
  [CampaignColumnsKeyConstant.OBJECTIVE]: 'Campaign Objectives',
  [CampaignColumnsKeyConstant.START_DATE]: 'Start Date',
  [CampaignColumnsKeyConstant.END_DATE]: 'End Date',
  [CampaignColumnsKeyConstant.ACCOUNTS]: 'Accounts',
  [CampaignColumnsKeyConstant.STORES]: 'Stores',
  [CampaignColumnsKeyConstant.ITEMS]: 'Items'
});

export const isTimeoutError = error => {
  return (
    error.graphQLErrors &&
    error.graphQLErrors.filter(graphQLError =>
      RETRYABLE_ERROR_TYPES.includes(graphQLError.errorType)
    ).length > 0
  );
};

export const refactorCampaigns = campaigns => {
  const campaignsData = campaigns ? campaigns : [];
  return campaignsData.map(campaign => ({
    ...campaign,
    selectedId: campaign.id
  }));
};
